import React from "react";
import NotificationButton from "~/components/Notifications/Button";
import HelpCenter from "./help_center";
import NavBarSupportedContent from "./nav_bar_supported_content";

const DefaultNavContent = () => (
  <ul className="navbar-nav ml-auto mr-auto-sm-down">
    <div className="d-flex">
      <NotificationButton />
      <HelpCenter />
    </div>
    <NavBarSupportedContent />
  </ul>
);

export default DefaultNavContent;
